import { Badge } from '@mantine/core';

function getContrastText(hex?: string | null): string {
  if (!hex) return '#fff';
  const clean = hex.replace('#', '');
  if (clean.length !== 6) return '#fff';
  const r = parseInt(clean.slice(0, 2), 16);
  const g = parseInt(clean.slice(2, 4), 16);
  const b = parseInt(clean.slice(4, 6), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.6 ? '#1A1B1E' : '#fff';
}

export function ColorBadge({ label, color }: { label: string; color?: string | null }) {
  return (
    <Badge
      variant="light"
      style={{
        backgroundColor: color ?? 'var(--mantine-color-gray-5)',
        color: getContrastText(color),
      }}
    >
      {label}
    </Badge>
  );
}